
export const PREVIEW_FILE_ATTEMPT = 'PREVIEW_FILE_ATTEMPT';
export type PREVIEW_FILE_ATTEMPT = typeof PREVIEW_FILE_ATTEMPT;

export const PREVIEW_FILE_SUCCESS = 'PREVIEW_FILE_SUCCESS';
export type PREVIEW_FILE_SUCCESS = typeof PREVIEW_FILE_SUCCESS;

export const PREVIEW_FILE_FAILURE = 'PREVIEW_FILE_FAILURE';
export type PREVIEW_FILE_FAILURE = typeof PREVIEW_FILE_FAILURE;

export const SET_PREVIEW_FILE_NUMBER_OF_PAGES = 'SET_PREVIEW_FILE_NUMBER_OF_PAGES';
export type SET_PREVIEW_FILE_NUMBER_OF_PAGES = typeof SET_PREVIEW_FILE_NUMBER_OF_PAGES;



// WEBPACK FOOTER //
// ./src/actions/project/get-document-preview/Types.tsx